export default __webpack_public_path__ + "media/images/icon_follow_requests-91c981db2537e17eabbc2587e9018694.png";